import React, { useEffect, useMemo } from "react";
import {
  MimaButton,
  MimaDropZone,
  MimaInput,
  MimaText,
  Modal,
} from "../../components";
import { Field, FieldArray, Form, Formik } from "formik";
import { imgUrlsToFiles } from "../../utils/utils";

const FieldInput = ({ field, ...props }) => {
  return <MimaInput {...field} {...props} />;
};

const UpdateStyleCategory = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  singleCategory,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4} width={38} align="center">
        Update Style Category
      </MimaText>

      <Formik
        initialValues={{
          categories: singleCategory
            ? singleCategory.categories.map((cat) => ({
                category: cat.category,
                subCategories: cat.subCategories,
                files: cat.imageUrl
                  ? [
                      {
                        name: cat?.imageUrl,
                        preview: cat?.imageUrl,
                      },
                    ]
                  : [],
              }))
            : [
                {
                  category: "",
                  subCategories: [""],
                  files: [],
                },
              ],
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          setFieldValue,
          values,
          errors,
          touched,
          handleSubmit,
        }) => (
          <Form>
            <FieldArray name="categories">
              {({ push, remove }) => (
                <>
                  {values.categories.map((category, index) => (
                    <div key={index}>
                      <MimaInput
                        labelTitle="Category"
                        placeholder="Enter Category Name"
                        id={`categories.${index}.category`}
                        name={`categories.${index}.category`}
                        value={values?.categories?.[index]?.category}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.categories?.[index]?.category}
                        touched={touched.categories?.[index]?.category}
                        mb={2}
                        mt={2}
                      />

                      <div style={{ width: "38rem" }}>
                        <MimaDropZone
                          title="Upload Category Image"
                          info="maximum image Size 1MB"
                          maxNumOfImages={1}
                          files={values?.categories?.[index]?.files}
                          setFiles={(newFiles) => {
                            setFieldValue(
                              `categories.${index}.files`,
                              newFiles
                            );
                          }}
                          labelTitle="Upload Image"
                          name={`categories.${index}.files`}
                          errorMsg={errors.categories?.[index]?.files}
                        />
                      </div>

                      <FieldArray name={`categories.${index}.subCategories`}>
                        {({ push, remove }) => (
                          <React.Fragment>
                            {category?.subCategories?.map((_, subIndex) => (
                              <div
                                key={subIndex}
                                style={{
                                  display: "flex",
                                  gap: "2rem",
                                  alignItems: "center",
                                  width: "38rem",
                                }}
                              >
                                <Field
                                  name={`categories.${index}.subCategories.${subIndex}`}
                                  component={FieldInput}
                                  labelTitle={`Sub Categories ${subIndex + 1}`}
                                  width={subIndex !== 0 ? 26 : 38}
                                />

                                {subIndex !== 0 ? (
                                  <MimaButton
                                    title="Remove"
                                    variant="filter"
                                    type="button"
                                    buttonColor="var(--color-error)"
                                    width={10}
                                    onClick={() => remove(subIndex)}
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            ))}
                            <MimaButton
                              title={
                                values?.categories?.[index]?.subCategories < 1
                                  ? "Add sub-category"
                                  : "Add Another sub-category"
                              }
                              variant="text"
                              type="button"
                              onClick={() => push("")}
                              mb={5}
                            />
                          </React.Fragment>
                        )}
                      </FieldArray>

                      {index !== 0 && (
                        <MimaButton
                          title="Remove Category"
                          type="button"
                          onClick={() => remove(index)}
                          buttonColor="var(--color-error)"
                        />
                      )}
                    </div>
                  ))}
                  <MimaButton
                    title="Add Category"
                    type="button"
                    onClick={() =>
                      push({ category: "", subCategories: [], files: [] })
                    }
                    mb={5}
                    mt={5}
                  />
                </>
              )}
            </FieldArray>

            <MimaButton
              title="Confirm Action"
              type="submit"
              onClick={handleSubmit}
              width={38}
              buttonColor="var(--color-admin)"
              loading={loading}
            />
          </Form>
        )}
      </Formik>

      {/* <Formik
        initialValues={{
          categories: singleCategory
            ? [
                {
                  category: singleCategory.category,
                  subCategories: singleCategory.subCategories,
                  imageUrl: "",
                },
              ]
            : [
                {
                  category: "",
                  subCategories: [""],
                  imageUrl: "",
                },
              ],
        }}
        onSubmit={onSubmit}
        // validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          setFieldValue,
          values,
          errors,
          touched,
          handleSubmit,
        }) => (
          <Form>
            <FieldArray name="categories">
              {({ push, remove }) => (
                <>
                  {values?.categories?.map((category, index) => (
                    <div key={index}>
                      <MimaInput
                        labelTitle="Category"
                        placeholder="Enter Category Name"
                        id={`categories.${index}.category`}
                        name={`categories.${index}.category`}
                        value={category.category}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.categories?.[index]?.category}
                        touched={touched.categories?.[index]?.category}
                        mb={2}
                        mt={2}
                      />

                      <div style={{ width: "38rem" }}>
                        <MimaDropZone
                          title="Upload Category Image"
                          info="maximum image Size 1MB"
                          // info2="maximum image Size 1MB"
                          maxNumOfImages={1}
                          files={files}
                          setFiles={setFiles}
                          labelTitle="Upload Image"
                          // name="imageUrl"
                          name={`categories.${index}.imageUrl`}
                        />
                        
                      </div>

                      <FieldArray name={`categories.${index}.subCategories`}>
                        {({ push, remove }) => (
                          <React.Fragment>
                            {category?.subCategories?.map((_, subIndex) => (
                              <div
                                key={subIndex}
                                style={{
                                  display: "flex",
                                  gap: "2rem",
                                  alignItems: "center",
                                  width: "38rem",
                                }}
                              >
                                <Field
                                  name={`categories.${index}.subCategories.${subIndex}`}
                                  component={FieldInput}
                                  labelTitle={`Sub Categories ${subIndex + 1}`}
                                  width={subIndex !== 0 ? 26 : 38}
                                />

                                {subIndex !== 0 ? (
                                  <MimaButton
                                    title="Remove"
                                    variant="filter"
                                    type="button"
                                    buttonColor="var(--color-error)"
                                    width={10}
                                    onClick={() => remove(subIndex)}
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            ))}
                            <MimaButton
                              title="Add Another Item"
                              variant="text"
                              type="button"
                              onClick={() => push("")}
                              mb={5}
                            />
                          </React.Fragment>
                        )}
                      </FieldArray>

                      {index !== 0 && (
                        <MimaButton
                          title="Remove Category"
                          type="button"
                          onClick={() => remove(index)}
                          buttonColor="var(--color-error)"
                        />
                      )}
                    </div>
                  ))}
                  <MimaButton
                    title="Add Category"
                    type="button"
                    onClick={() =>
                      push({ category: "", subCategories: [""], imageUrl: "" })
                    }
                    mt={5}
                    mb={5}
                  />
                </>
              )}
            </FieldArray>

            <MimaButton
              title="Confirm Action"
              type="submit"
              onClick={handleSubmit}
              width={38}
              buttonColor="var(--color-admin)"
              loading={loading}
            />
          </Form>
        )}
      </Formik> */}
    </Modal>
  );
};

export default UpdateStyleCategory;
